package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class NavbarDto(
    @SerialName("title") val title: String? = null,
    @SerialName("style") val style: String? = null,
    @SerialName("color") val color: String? = null,
    @SerialName("image") val image: String? = null,
    @SerialName("actions") val actions: List<ActionDto>? = null,
)
